export default __webpack_public_path__ + "static/media/vbnb.d43846ce.png";